import _ from 'lodash';
import { changeMobileDesign } from '../../apis/firebase';
import { ERROR_CHANGE_DESIGN, SUCCESS_UPDATE_TEXT } from '../../constants';
import { sendCloudWatchAlert } from '../../utils/applicationError';
import { showNotification } from '../../components/Notification/Notification.view';
import { TITLE_DESCRIPTION, CLIENT_SPACE, NEW_PRODUCTS_DESCRIPTION, LOYALTY_NAME } from '../../constants/dataConfig'
import { isStringNotNull } from '../../utils/tools';
import { intersectionObjects } from '../../utils/shopUtils';
import { getALLMenus } from '../../apis/backend';
export const initStates = async (props, setStateObj) => {
  const {
    url = null,
    facebook = null,
    instagram = null,
    linkedin = null,
    titleDescription = TITLE_DESCRIPTION,
    clientSpace = CLIENT_SPACE,
    myLoyalty,
    name = LOYALTY_NAME,
    newProducts,
    newProductsDescription = NEW_PRODUCTS_DESCRIPTION,
    myAccount,
    myOrders,
    slides
  } = props;
  await setStateObj({
    url,
    isLoading: false,
    isLoadingProducts: false,
    facebook,
    instagram,
    linkedin,
    titleDescription,
    clientSpace,
    fedilityPicture: myLoyalty,
    myAccountImage: myAccount,
    myOrdersImage: myOrders,
    slidesPictures: getSlides(slides),
    fedilityImage: myLoyalty,
    myAccountPicture: myAccount,
    myOrdersPicture: myOrders,
    slidesImages: getSlides(slides),
    name,
    products: newProducts,
    newProductsDescription
  });
};

export const slideImage = async (croppedImage, setStateObj, id) => {
  setStateObj({ [id]: croppedImage.split(',')[1] });
};
export const depositImage = (setStateObj, id) => {
  setStateObj({ [id]: null });
};
export const setCroppedSliderImage = async (croppedImage, slidesImages, setStateObj, index) => {
  setStateObj({

    slidesImages: {
      ...slidesImages,
      [index]: croppedImage.split(',')[1]
    }
  });
};

export const handleRemoveSliderImage = async (slidesImages, setStateObj, index) => {
  setStateObj({
    slidesImages: {
      ...slidesImages,
      [index]: ''
    }
  });
};

export const changeDesignMobile = async (stateObj, produits, setStateObj, props) => {
  const {
    selected,
    slidesImages,
    products = [],
    titleDescription,
    clientSpace,
    url,
    facebook,
    linkedin,
    instagram,
    name,
    newProductsDescription,
    fedilityImage,
    myAccountPicture,
    myOrdersPicture
  } = stateObj

  const pictures = _.filter(slidesImages, elm => elm !== '')
  const productStyle = props.selectedProduct === 1 ? 2 : 1

  const data = ({
    selected,
    pictures,
    products: intersectionObjects(Object.values(products), produits),
    titleDescription,
    clientSpace,
    url: getValidUrl(url),
    facebook: getValidUrl(facebook),
    linkedin: getValidUrl(linkedin),
    productStyle,
    instagram: getValidUrl(instagram),
    name,
    newProductsDescription,
    fedilityPicture: fedilityImage,
    myAccountImage: myAccountPicture,
    myOrdersImage: myOrdersPicture,
    enabled: props?.enabled
  })
  try {
    setStateObj({ isLoading: true });
    await changeMobileDesign(
      data, props.config
    );
    showNotification(
      'light',
      'ltr',
      'primary',
      SUCCESS_UPDATE_TEXT,
      `Les paramétres de design application mobile ont bien été modifiés.`
    );
    setStateObj({
      loadingCropper: selected === 0 && true
    });

  } catch (e) {
    sendCloudWatchAlert(`Error update web site ${e}`);
    props.openErrorModal(ERROR_CHANGE_DESIGN);
  }
  setStateObj({ isLoading: false });
};
export const getSections = async (setStateObj) => {
  setStateObj({ isLoadingProducts: true })
  const menus = await getALLMenus();
  const sections = _.map(menus, elm => {
    return getSectionsWithEnabledProducts(elm.sections);
  });
  let sectionWithEnabledProducts = {};
  sectionWithEnabledProducts = sections[0];
  for (let i = 1; i < sections.length; i++) {
    sectionWithEnabledProducts = _.unionBy(sectionWithEnabledProducts, sections[i], 'key');
    sectionWithEnabledProducts = _.uniqBy(sectionWithEnabledProducts, 'name');
  }
  setStateObj({ isLoadingProducts: false });
  return _.sortBy(sectionWithEnabledProducts, o => o.name);
};

export const handleCheckBox = (products, setStateObj, value) => {
  const currentIndex = _.indexOf(_.keys(products), value.key);
  if (currentIndex === -1) {
    _.assign(products, { [value.key]: value });
  }
  else {
    delete products[value.key]
  }
  setStateObj({ products });
};

export const handleSearchChange = (e, setStateObj, setSearchTerm, stateObj) => {
  setSearchTerm(e.target.value);
  handleSearchBlur(setStateObj, e.target.value, stateObj);
};
export const handleSearchBlur = async (setStateObj, searchTerm, stateObj) => {
  const filteredSections = {};
  _.filter(stateObj.allSections, section => {
    _.filter(section.products, product => {
      if (product?.name?.toLowerCase().includes(searchTerm?.toLowerCase())) {
        Object.assign(filteredSections, {
          [section.key]: {
            ...section,
            products: _.filter(section.products, product =>
              product?.name?.toLowerCase().includes(searchTerm?.toLowerCase())
            ),
          },
        });
      }
    });
  });
  setStateObj({ sections: filteredSections });
};

export const getSlides = slides => {
  const newArray = Array(3).fill('');
  if (slides) {
    if (slides.length === 3) {
      return slides;
    } else if (slides.length === 2) {
      return newArray.splice(0, 1).concat(slides);
    }

    return newArray.splice(0, 2).concat(slides);
  }

  return newArray;
};
const getEnabledProducts = products => {
  return _.filter(_.keys(products), elm =>
    !(products[elm].disabled || (products[elm].disabledCC &&
      products[elm].disabledCS && products[elm].disabledDelivery))
  ).reduce((obj, cur) => ({ ...obj, [cur]: products[cur] }), {});
};

export const getSectionsWithEnabledProducts = commonSections => {
  const enabledSections = {};
  _.map(commonSections, section => {
    if (!section.hidden) {
      _.map(section.products, product => {
        _.assign(enabledSections, {
          [section.key]: {
            ...section,
            products: getEnabledProducts(section.products)
          }
        });
      });
    }

  });

  return _.filter(enabledSections, section => _.size(section.products) > 0);
};


export const getValidUrl = link => {
  const prefix = 'https://';
  if (isStringNotNull(link)) {
    if (link.indexOf(prefix) === -1) {
      return prefix.concat(link);
    }
    return link;
  }
  return null;
};
